// ── sessionStorage caches ──────────────────────────────────────────────────
// Bump CACHE_V when the stored format changes so stale entries are ignored.
// v3: chapter text gained "#<verse> <heading>" lines (Psalm superscriptions)
export const CACHE_V = 'v3';

// Chapter outlines cache — keyed per book + chapter + lang
export function getOutlineCache(bookAbbr, chapter, lang) {
  try { const r = sessionStorage.getItem(`bol_${CACHE_V}_${bookAbbr}_${chapter}_${lang}`); return r ? JSON.parse(r) : null; }
  catch { return null; }
}
export function setOutlineCache(bookAbbr, chapter, lang, data) {
  try { sessionStorage.setItem(`bol_${CACHE_V}_${bookAbbr}_${chapter}_${lang}`, JSON.stringify(data)); } catch (_) {}
}

// Book intro + full outline cache — keyed per book + lang
export function getBookIntroCache(bookAbbr, lang) {
  try { const r = sessionStorage.getItem(`bi_${CACHE_V}_${bookAbbr}_${lang}`); return r ? JSON.parse(r) : null; }
  catch { return null; }
}
export function setBookIntroCache(bookAbbr, lang, intro, outline) {
  try { sessionStorage.setItem(`bi_${CACHE_V}_${bookAbbr}_${lang}`, JSON.stringify({ intro, outline })); } catch (_) {}
}

// ── Chapter data cache (sessionStorage, keyed per book+chapter) ────────────
export function getChapterCache(bookAbbr, chapter) {
  try { const r = sessionStorage.getItem(`bch_${CACHE_V}_${bookAbbr}_${chapter}`); return r ? JSON.parse(r) : null; }
  catch { return null; }
}
export function mergeChapterCache(bookAbbr, chapter, newData) {
  const merged = { ...(getChapterCache(bookAbbr, chapter) || {}), ...newData };
  try { sessionStorage.setItem(`bch_${CACHE_V}_${bookAbbr}_${chapter}`, JSON.stringify(merged)); } catch (_) {}
  return merged;
}
